// src/modules/app-views/invoices/pages/Init/components/tableColumns/items/itemTotalColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import translateX from 'utils/translateX';
import financialService from 'services/financialService';
import { resolveItemFontSize } from './index';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders the total price column for item subtables.
// options.size: 'small' (11px, default) | 'middle' (14px)
function itemTotalColumn(options = {}) {
  const { size } = options;
  const fontSize = resolveItemFontSize(size, 11);

  return {
    title: translateX('total'),
    dataIndex: 'totalPrice',
    width: 120,
    align: 'right',
    sorter: (a, b) =>
      (a?.totalPrice || a?.totalValue || 0) - (b?.totalPrice || b?.totalValue || 0),
    render: (_, item) => {
      const value = item?.totalPrice ?? item?.totalValue;
      return (
        <Text strong style={{ fontSize }}>
          {value != null ? financialService.formatCurrency(value) : '—'}
        </Text>
      );
    },
  };
}

export default itemTotalColumn;
